<template>
  <div class="wrap client-list-wrap">
    <div class="top-header">
      <incBack></incBack>
      <h3>고객 / 코칭 일지</h3>
    </div>
    <div class="body-wrap">
      <incMenuShot></incMenuShot>
      <div class="clear mt-40 search">
        <div class="w-100per float-left">
          <ul>
            <li>
              <select name="" id="" v-model="input.whetherWriteFlag" @change="getClientList()">
                <option value="">전체</option>
                <option value="ongoing">진행중</option>
                <option value="complete">완료</option>
              </select>
            </li>
          </ul>
        </div>
      </div>

      <div class="client-list">
        <ul>
          <li class="clear" @click="viewDetail(item.userIdx)" v-for="(item, index) in clientList" :key="index">
            <h1 class="float-left">{{ item.userName }}</h1>
            <p class="float-left">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{ item.companyName }}</p>
          </li>
          <!-- <li class="clear" @click="viewDetail()">
                        <h1 class="float-left">정수빈</h1>
                    </li>
                    <li class="clear" @click="viewDetail()">
                        <h1 class="float-left">손채윤</h1>
                        <p class="float-left">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;두산중공업</p>
                    </li> -->
        </ul>
      </div>

      <!-- <div class="coaching-list">
                <div class="coaching">
                    <ul>
                        <li class="clear more">
                            <div class="w-80per float-left">
                                <div>
                                    <span>화상</span>
                                    <h1>김소연</h1>
                                </div>
                                <p class="date">2021.08.10  09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;<b class="bold">2/10</b></p>
                            </div>
                            <div class="w-20per float-left">
                                <p class="state">당일 취소</p>
                            </div>
                        </li>
                        <li class="clear more">
                            <div class="w-80per float-left">
                                <div>
                                    <span>화상</span>
                                    <h1>김소연</h1>
                                </div>
                                <p class="date">2021.08.10  09:00~10:00&nbsp;&nbsp;|&nbsp;&nbsp;<b class="bold">2/10</b></p>
                            </div>
                            <div class="w-20per float-left">
                                <p class="state active">코칭 완료</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->

      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incTab from "@/components/inc/inc_tab.vue";
import incMenuShot from "@/components/inc/inc_menu_shot.vue";
export default {
  name: "client_list",
  data: () => ({
    clientList: [],
    input: {
      whetherWriteFlag: "",
    },
  }),
  components: {
    incBack,
    incTab,
    incMenuShot,
  },
  mounted() {
    this.getClientList();
  },
  methods: {
    getClientList() {
      let params = this.input;
      this.axios
        .get("/front/coarching/user/list", { params })
        .then((res) => {
          if (res.data.success) {
            this.clientList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewDetail(userIdx) {
      this.$router.push({ name: "client_detail", params: { userIdx: Number(userIdx) } });
    },
  },
};
</script>
